import * as ActionTypes from '../constants/ActionTypes';

export const setShowApiErrorModal = isShowErrorModal => ({
    type: ActionTypes.SET_SHOW_API_ERROR_MODAL,
    payload: isShowErrorModal
});



// WEBPACK FOOTER //
// ./src/actions/Api.js